import { useState, memo, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import AuthWrapper from '../components/authWrapper';
import Field from '@/components/formFields/InputField/Field';
import ActionBtn from '@/components/ActionBtn';
import { succToast } from '@/utils';
import { errToast } from '@/utils';
import { ResendCode } from '@/api/endpoints';


const CodeForm = ({ onSubmit }) => {

    const [code, setCode] = useState('')
    const [loading, setLoading] = useState(false)
    const { t } = useTranslation()
    const {state} = useLocation()


    const handleResendCode = () => {
        setLoading(true)
        let mail = state?.email
        ResendCode({ email: mail }).then(res => {
            succToast(t("Code is sent to your email"))
        }).catch(() => {
            errToast(t("failed to send code"))
        }).finally(() => {
            setLoading(false)
        })
    }
   

    return (

        <AuthWrapper>
            <div className='inputsContainer'>
                    <Field className='col-md-12' lang='any' value={code} setValue={setCode} placeholder={t("Code")} label={t("Code")} type="text" name="code" />
            </div>

            <div className='inputsContainer' onClick={handleResendCode}> {loading ? t("loading") : t("resend-code")}</div>
            
            <ActionBtn isDisabled={loading} className={"login-btn"} onApply={e => onSubmit(e, { code, setLoading })} title={"Submit Code"} />

            <div className='donot-have-account-container'>
                {t("backTo")} <Link to='/auth/log-in'>{t("login")}</Link>
            </div>
        </AuthWrapper>

    );
}

export default memo(CodeForm);

